import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0047158f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "error-page" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Something went wrong", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Error 404", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("The page you requested could not be found. If you are expecting to see something here please context "),
  /*#__PURE__*/_createElementVNode("a", { href: "mailto:support@derivitec.com" }, "support@derivitec.com"),
  /*#__PURE__*/_createTextVNode(".")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_panel = _resolveComponent("panel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_panel, null, {
      default: _withCtx(() => [
        _hoisted_2,
        _hoisted_3,
        _hoisted_4,
        _createElementVNode("p", null, [
          _createVNode(_component_router_link, {
            to: "/",
            class: "button"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Return to homepage")
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    })
  ]))
}